import req from "@/assets/js/axios"

// 8分钟平台相关接口
export default {
  //获取热门路演
  getHotRoadShows: (params) => {
    return req.apiAxios('POST', '/eightHost/roadshow/RoadShowController/getHotRoadShows', params);
  },
  //条件查询活动
  getEightActivities: (params) => {
    return req.apiAxios('POST', '/eightHost/activity/ActivityController/getActivities', params);
  },
  //获取热门企业
  getHotEnterprises: (params) => {
    return req.apiAxios('POST', '/eightHost/enterprise/EnterpriseController/getHotEnterprises', params);
  },
  //获取热门投资机构
  getHotInvests: (params) => {
    return req.apiAxios('POST', '/eightHost/invest/InvestController/getHotInvests', params);
  },
  //获取热门比赛
  getHotCompetitions: (params) => {
    return req.apiAxios('POST', '/eightHost/competition/CompetitionController/getHotCompetitions', params);
  },

  //条件查询比赛
  getFontCompetitions: (params, auth = true) => {
    return req.apiAxios('POST', '/eightHost/competition/CompetitionController/getFontCompetitions', params, auth);
  },
  //校验报名资格
  checkSign: (params, auth = true) => {
    return req.apiAxios('POST', '/eightHost/business/competitionsign/BCompetitionSignController/checkSign', params, auth);
  },
  //条件查询企业
  getMyEnterprises: (params) => {
    return req.apiAxios('POST', '/eightHost/enterprise/EnterpriseController/getEnterprises', params);
  },
  //条件查询路演
  getRoadShows: (params) => {
    return req.apiAxios('POST', '/eightHost/roadshow/RoadShowController/getRoadShows', params);
  },
  //条件查询专辑路演关联
  getAlbumRoadShows: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/albumroadshow/AlbumRoadShowController/getAlbumRoadShows', params);
  },
  //条件查询特色专场
  getAlbums: (params) => {
    return req.apiAxios('POST', '/eightHost/album/AlbumController/getAlbums', params);
  },
  //更新路演浏览量
  updateRoadShowBrowse: (params) => {
    return req.apiAxios('POST', '/eightHost/roadshow/RoadShowController/updateRoadShowBrowse', params);
  },
  //条件查询路演评分
  getRoadShowScores: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/roadshowscore/RoadShowScoreController/getRoadShowScores', params);
  },
  //创建路演评分
  createRoadShowScore: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/roadshowscore/RoadShowScoreController/createRoadShowScore', params);
  },
  //条件查询用户关注路演
  getUserRoadShows: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/userroadshow/UserRoadShowController/getUserRoadShows', params);
  },
  //添加用户关注路演
  createUserRoadShow: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/userroadshow/UserRoadShowController/createUserRoadShow', params);
  },
  //删除用户关注路演
  deleteUserRoadShow: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/userroadshow/UserRoadShowController/deleteUserRoadShow', params);
  },
  //条件查询云相册
  getFontCloudPhotos: (params) => {
    return req.apiAxios('POST', '/eightHost/intermediate/cloudphoto/CloudPhotoController/getFontCloudPhotos', params);
  },
  //企业生成统计表单
  generatePdf: (params) => {
    return req.apiAxios('POST', '/bussiness/enterprisestatistic/BEnterpriseStatisticController/starry-security/generatePdf', params,true);
  },
}
